<template>
    <div class="app-container" style="height: 100%">
        <page-layout :footer-box-shadow="false">
            <div v-if="contact && brief" style="max-width: 100%">
                <network-connection-info
                    context="brief"
                    :contact-id="contact.id"
                    :live-url="contact.live_url"
                    :brief-id="brief.id"
                    :network-id="networkId"
                    :instagram-graph-required="instagramGraphRequired"
                    @go-back="handleConnected"
                    @show-instagram-faq="handleInstagramFaq"
                />
            </div>

            <template #footer>
                <g-row type="flex" justify="space-around" :gutter="[8, 8]">
                    <g-column :span="24">
                        <g-typography tag="p" text-align="center" size="small">
                            <span v-if="networkId === INSTAGRAM_ID && !useThirdParty">
                                Need Help? <a @click="handleInstagramFaq">Read our FAQ's</a>
                            </span>
                            <span v-else-if="helpDocLink">
                                Learn more about connecting at
                                <a :href="helpDocLink" target="_blank">GRIN Help</a>.
                            </span>
                        </g-typography>
                    </g-column>

                    <g-column>
                        <powered-by-grin :is-white-labeled="isWhiteLabeled" />
                    </g-column>
                </g-row>
            </template>
        </page-layout>
    </div>
</template>

<script>
    import { get } from 'lodash';
    import { getMeta } from '../../../../../../src/helpers';
    import { INSTAGRAM_ID, TIKTOK_ID, PINTEREST_ID } from '../../../../../constants/networks';
    import { FAQ_CONNECTING_TIKTOK, FAQ_CONNECTING_PINTEREST } from '../../../../../constants/faqs';
    import PageLayout from '../../../../layouts/PageLayout.vue';
    import NetworkConnectionInfo from '../../../networks/partials/NetworkConnectionInfo.vue';
    import { useFeatureFlagsStore } from '../../../../../../stores';

    export default {
        name: 'ActivationBriefConnectNetworkView',
        props: {
            brief: {
                type: Object,
                default: null
            },
            contact: {
                type: Object,
                default: null
            },
            networkId: {
                type: Number,
                default: null
            },
            instagramGraphRequired: {
                type: Boolean,
                default: false
            }
        },
        components: {
            NetworkConnectionInfo,
            PageLayout
        },
        data() {
            return {
                INSTAGRAM_ID
            };
        },

        computed: {
            host() {
                return getMeta('routing-domain');
            },

            /**
             * Whether or not the account is white labeled
             */
            isWhiteLabeled() {
                return get(this, 'brief.is_white_labeled', false);
            },

            helpDocLink() {
                const links = {
                    [TIKTOK_ID]: FAQ_CONNECTING_TIKTOK,
                    [PINTEREST_ID]: FAQ_CONNECTING_PINTEREST
                };

                return [TIKTOK_ID, PINTEREST_ID].includes(this.networkId) ? links[this.networkId] : null;
            },

            useThirdParty() {
                return useFeatureFlagsStore().data?.['third-party-meta-live-site-authentication'] || false;
            }
        },

        /**
         * The component methods
         *
         * @type {Object}
         */
        methods: {
            /**
             * Handle FAQ link click
             */
            handleInstagramFaq() {
                this.$router.push({ name: 'v2.activation.brief.networks.faq' });
            },

            /**
             * Handle a successful connection
             */
            handleConnected() {
                this.$router.push({
                    name: 'v2.activation.brief.networks',

                    query: {
                        connectedNetworkId: this.networkId
                    }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .margin-bottom-normal {
        margin-bottom: 1rem;
    }
</style>
